$(document).ready(function(e){
//    $.scrollify({
//        section:'section',
//        scrollbars:false
//    })
})